/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { useCommitMutation } from '@@views/_common/client/hooks/useCommitMutation';
import SaveSimulationDemographyMutation from '../graphql/mutations/SaveSimulationDemographyMutation.js';

export const useSaveSimulationDemographyMutation = () => {
  return useCommitMutation(SaveSimulationDemographyMutation, {
    dataProp: 'saveSimulationDemography_M_simulation_demography'
  });
};

export default useSaveSimulationDemographyMutation;
